const RANGE_FACET_KEY = 'Price';
const FILTER_PREFIX = 'filter.';

const FILTER_PARAM_TO_API = {
  COLOR: 'color',
  Gender: 'gender',
  Fit_guide: 'custom.fit_guide',
  Pursuits: 'custom.pursuits',
  Discount: 'custom.discount',
  Prd_type: 'custom.prd_type',
  Pillars: 'custom.pillars',
  Usps: 'custom.usps',
  SIZE: 'size',
};

function toFilterParam(facetKey) {
  return `${FILTER_PREFIX}${facetKey}`;
}

function fromFilterParam(paramKey) {
  return paramKey.startsWith(FILTER_PREFIX)
    ? paramKey.slice(FILTER_PREFIX.length)
    : null;
}

function isFilterParam(paramKey) {
  return paramKey.startsWith(FILTER_PREFIX);
}

let isRendering = false;
let eventsBound = false;
let isLoadingMore = false;
let queuedMain = false;

let isCollections = false
const collectionsPage = document.querySelector('.voyado-collections-page')

if (collectionsPage && collectionsPage != null) {
  isCollections = true
}

const limit = 48;

let currentSkip = 0;
let baseTotalHits = 0;
let totalHitsState = 0;
let hasMorePrimaryPages = false;
let failedProducts = 0;
let renderedCount = 0;

let cachedForYou = null;
let hasTakenOverCollection = false;

let sizeFacetIdToLabel = Object.create(null);

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const v_search = document.querySelector('#voyado-search-input');

const tick = `<svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 4.33333L3.76923 7L10 1" stroke="white"/>
</svg>`;

const chev = `<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 6.5L6 1.5L11 6.5" stroke="#97999B"/>
</svg>`;

// eslint-disable-next-line compat/compat
let queryParams = new URLSearchParams(window.location.search);
let searchQuery = '';
const SCROLL_POSITION_KEY = 'voyado_plp_scroll_position';
let sort = 'RELEVANCE';

function saveScrollPosition() {
  if (currentSkip === 0) {
    const payload = { y: window.scrollY, url: window.location.href };
    sessionStorage.setItem(SCROLL_POSITION_KEY, JSON.stringify(payload));
  }
}

function restoreScrollPosition() {
  const saved = sessionStorage.getItem(SCROLL_POSITION_KEY);

  if (!saved) {
    return false;
  }

  try {
    const data = JSON.parse(saved);

    if (data.url !== window.location.href) {
      return false;
    }

    // Flush layout so injected PLP height is applied before scrolling (no rAF delay).
    void document.documentElement.offsetHeight;
    const maxY = Math.max(
      0,
      document.documentElement.scrollHeight - window.innerHeight,
    );
    window.scrollTo({ top: data.y, left: 0, behavior: 'instant' });
    sessionStorage.removeItem(SCROLL_POSITION_KEY);

    return true;

  } catch (e) {
    return false;
  }
}

// Initialize search input
if (queryParams.has('q')) {
  searchQuery = queryParams.get('q');
  v_search.value = searchQuery;
  document.querySelector('.search-results-header #results-title').innerHTML = `<span class="messaging">Search results for</span><span class="query">${searchQuery}</span>`;
}
if (queryParams.has('sort')) sort = queryParams.get('sort');

// Debounce helper
function debounce(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

function isValidProductCard(html) {
  return (
    html.includes('prd-Card') &&
    !html.includes('template-404') &&
    !html.includes('Page Not Found') &&
    !html.includes('shopify-section-header') &&
    !html.includes('<title>404</title>')
  );
}

// Deduplicated product fetching
const renderedTickets = new Set();
async function getProductInfo(handle, ticket) {
  if (!handle) return null;

  let path = String(handle);

  // Voyado uses '/not-valid' as a placeholder for products without a real URL
  if (path === '/not-valid' || path === 'not-valid') return null;

  try {
    if (path.startsWith('http')) {
      path = new URL(path).pathname;
    } else if (path.startsWith('/')) {
      // Already a full path — use as-is (avoids double-slash for placeholder links like /not-valid)
    } else if (!path.includes('product')) {
      path = `/products/${path}`;
    }
  } catch {
    path = `/products/${handle}`;
  }

  try {
    const res = await fetch(`${path}?view=simple`);
    if (!res.ok) return null;
    const html = await res.text();
    if (!isValidProductCard(html)) return null;
    return { html, ticket, handle: productHandleFromLink(path) };

  } catch {
    return null;
  }
}

function productHandleFromLink(link) {
  if (!link) return '';

  try {
    const path = String(link).startsWith('http') ? new URL(link).pathname : String(link);
    const match = path.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  } catch {
    return '';
  }
}

function productHandleFromGroup(product) {
  const fromLink = productHandleFromLink(product?.link);
  if (fromLink) return fromLink;

  const fromKey = productHandleFromLink(product?.key);
  if (fromKey) return fromKey;

  const key = String(product?.key || '');
  if (key && !key.includes('/')) return key;

  return '';
}

function wrapProductCard(html, ticket, handle) {
  const item = document.createElement('div');
  item.className = 'prd-List_Item';
  if (ticket) item.dataset.ticket = ticket;
  if (handle) item.dataset.productHandle = handle;
  item.innerHTML = html;
  return item;
}

function indexNativeCards(container) {
  const map = new Map();

  container.querySelectorAll('.prd-List_Item[data-product-handle]').forEach((el) => {
    const handle = el.dataset.productHandle;
    if (handle && !map.has(handle)) map.set(handle, el);
  });

  return map;
}

function setVoyadoPlpState(state) {
  const root = document.querySelector('[data-voyado-plp]');
  if (root) root.setAttribute('data-voyado-plp', state);

  if (state !== 'pending') {
    document.documentElement.classList.remove('collection-skeleton');
  }
}

/**
 * Resolves once the main images of the first N visible cards have settled, so the
 * skeleton can drop when the top row has real content. Product cards ship a 1x1
 * placeholder `src` plus a lazy `srcset`, so freshly injected cards paint empty
 * until their image lands.
 */
function waitForVisibleCardImages(container, limit = 3) {
  const pending = new Set();
  let watched = 0;

  for (const item of container.querySelectorAll('.prd-List_Item')) {
    if (watched >= limit) break;

    const rect = item.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) continue;

    const img = item.querySelector('.prd-Card_Image > .rsp-Image img');
    if (!img) continue;

    watched += 1;
    if (!img.complete) pending.add(img);
  }

  if (pending.size === 0) return Promise.resolve();

  return new Promise((resolve) => {
    const onSettled = (event) => {
      const img = event.currentTarget;
      if (!pending.delete(img)) return;
      img.removeEventListener('load', onSettled);
      img.removeEventListener('error', onSettled);
      if (pending.size === 0) resolve();
    };

    pending.forEach((img) => {
      img.addEventListener('load', onSettled);
      img.addEventListener('error', onSettled);
    });

    pending.forEach((img) => {
      if (img.complete) {
        onSettled({ currentTarget: img });
      }
    });
  });
}

function disableNativeLoadMore() {
  const list = document.querySelector('load-more-list');
  if (!list) return;

  list.setAttribute('loading', 'true');
  list.querySelector('[data-load-more-list-el="pagination"]')?.setAttribute('hidden', '');
}

async function renderProducts(results, container, { countFailures = false } = {}) {
  const fragment = document.createDocumentFragment();

  results.forEach(result => {
    if (!result) {
      if (countFailures) handleFailedProduct();
      return;
    }

    renderedCount++;
    fragment.appendChild(wrapProductCard(result.html, result.ticket, result.handle));
  });

  container.appendChild(fragment);

  await initAtc(container);
}

async function initAtc(container) {
  const appendedItems = container.querySelectorAll('product-quick-add');

  appendedItems.forEach(item => {
    if (typeof item.syncDom === 'function') {
      item.syncDom();
    }
  });
}

function handleFailedProduct() {
  failedProducts++;
}

function updateDashboardCount() {
  const resultsAmount = document.querySelector('.search-results-header #results-amount');

  if (resultsAmount) {
    resultsAmount.innerHTML = `[${totalHitsState}]`;
  }

}

// Render main products
async function createProducts(productGroups) {
  const productList = document.querySelector('.search-results__results');
  if (!productList) return;

  if (!productGroups || productGroups.length === 0) {
    if (currentSkip === 0 && !isCollections) {
      productList.innerHTML = '';
    }
    if (isCollections && currentSkip === 0) setVoyadoPlpState('failed');
    return;
  }

  const uniqueGroups = productGroups.filter(group => {
    const ticket = group.products[0].ticket;
    if (renderedTickets.has(ticket)) return false;
    renderedTickets.add(ticket);
    return true;
  });

  const plpPagination = document.querySelector('.search-results-container .pagination');

  if (currentSkip > 0 && plpPagination) {
    plpPagination.classList.add('loading');
  }

  const reuseNative = isCollections && currentSkip === 0;
  const nativeCards = reuseNative ? indexNativeCards(productList) : new Map();
  const ordered = [];
  const toFetch = [];

  uniqueGroups.forEach((group) => {
    const product = group.products[0];
    const handle = productHandleFromGroup(product);
    const existing = handle ? nativeCards.get(handle) : null;

    if (existing) {
      existing.dataset.ticket = product.ticket;
      existing.dataset.productHandle = handle;
      existing.classList.add('prd-List_Item');
      ordered.push({ el: existing });
      nativeCards.delete(handle);
    } else {
      const pending = { ticket: product.ticket, handle, link: product.link, el: null };
      ordered.push(pending);
      toFetch.push(pending);
    }
  });

  if (toFetch.length) {
    const results = await Promise.all(
      toFetch.map((item) => getProductInfo(item.link, item.ticket))
    );

    results.forEach((result, i) => {
      const item = toFetch[i];
      if (!result) {
        handleFailedProduct();
        return;
      }
      item.el = wrapProductCard(result.html, item.ticket, item.handle || result.handle);
    });
  }

  const fragment = document.createDocumentFragment();
  ordered.forEach((item) => {
    if (item.el) fragment.appendChild(item.el);
  });

  if (reuseNative && fragment.childNodes.length === 0) {
    setVoyadoPlpState('failed');
    plpPagination?.classList.remove('loading');
    return;
  }

  if (reuseNative) {
    const current = Array.from(productList.querySelectorAll(':scope > .prd-List_Item'));
    const sameOrder =
      !toFetch.length &&
      ordered.length === current.length &&
      ordered.every((item, i) => item.el === current[i]);

    if (!sameOrder) {
      const previousHeight = productList.offsetHeight;
      productList.replaceChildren(fragment);
      productList.style.minHeight = `${previousHeight}px`;
    }
  } else if (currentSkip === 0) {
    productList.replaceChildren(fragment);
  } else {
    productList.appendChild(fragment);
  }

  plpPagination?.classList.remove('loading');

  await initAtc(productList);

  renderedCount = productList.querySelectorAll('.prd-List_Item').length;
  updatePagination();
  updateDashboardCount();
}

// Secondary products
async function createSecondaryProducts(productGroups, totalHits) {

  if (!productGroups || productGroups.length === 0) {
    document.querySelector('#results-title--secondary').style.display = 'none'
    return
  }

  document.querySelector('#results-title--secondary').style.display = 'block'

  const productList = document.querySelector('.search-results__results--secondary');
  productList.innerHTML = '';

  const displayHits = Math.min(totalHits, 12);

  const results = await Promise.all(
    productGroups.slice(0, 12).map(group =>
      getProductInfo(group.products[0].link, group.products[0].ticket)
    )
  );

  if (results.length === 0) return

  await renderProducts(results, productList);
  document.querySelector('#results-amount--secondary').innerHTML = `${displayHits} products`;
}

// Scroll helper
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'auto' });
}

// Clear filters
function clearFilters() {
  // eslint-disable-next-line compat/compat
  const url = new URL(window.location.href);
  [...url.searchParams.keys()]
    .filter(isFilterParam)
    .forEach(k => url.searchParams.delete(k));
  window.history.replaceState({}, '', url);
}

function clearFiltersOnClick() {
  document.querySelectorAll('.clear-filters').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      document.querySelectorAll('.facet').forEach(f => f.classList.remove('active'));
      clearFilters();
      document.querySelector('.selected-filter-amount').innerHTML = ``;
      currentSkip = 0;
      main();
    });
  });
}

// Facet container state
function getActiveFacetContainers() {
  const activeContainers = {};
  document.querySelectorAll('.voyado-results__facets .facet-container').forEach(container => {
    const key = container.querySelector('h2')?.textContent?.trim();
    if (key) activeContainers[key] = container.classList.contains('active');
  });
  return activeContainers;
}
function restoreActiveFacetContainers(activeContainers) {
  document.querySelectorAll('.facet-container').forEach(container => {
    const key = container.querySelector('h2')?.textContent?.trim();
    if (key && activeContainers[key]) container.classList.add('active');
  });
}

// Facets
function buildFacetListItems(facetKey, facetValues = [], searchQuery) {
  return (facetValues || []).map(value => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    params.delete('origin');

    const paramKey = toFilterParam(facetKey);
    const existing = params.get(paramKey);
    const existingValues = existing ? existing.split('|').map(String) : [];
    const isActive = existingValues.includes(String(value.id));

    const set = new Set(existingValues);
    if (isActive) set.delete(String(value.id));
    else set.add(String(value.id));

    if (set.size > 0) params.set(paramKey, Array.from(set).join('|'));
    else params.delete(paramKey);

    return `<li class="facet${isActive ? ' active' : ''}" data-facet="${facetKey}">
      <a href="?${params.toString()}"><span class="facet-check">${tick}</span>${value.label.toLowerCase()}</a>
    </li>`;
  }).join('');
}

function buildCheckboxFacetItem(facet) {
  const url = new URL(window.location.href);
  url.searchParams.delete('origin');
  const filterParamKey = toFilterParam(facet.id);
  const isActive = url.searchParams.get(filterParamKey) === 'true';
  if (isActive) {
    url.searchParams.delete(filterParamKey);
  } else {
    url.searchParams.set(filterParamKey, 'true');
  }
  return `
    <li class="facet${isActive ? ' active' : ''}" data-facet="${facet.id}">
      <a href="?${url.searchParams.toString()}"><span class="facet-check">${tick}</span>${facet.label.toLowerCase()}</a>
    </li>
  `;
}

// Global debounced main
const debouncedMain = debounce(main, 300);

function createFacets(facets, sortOptions, autoCorrect) {

  if (autoCorrect && typeof autoCorrect === 'string') {
    const url = new URL(window.location.href);
    url.searchParams.set('q', autoCorrect);
    history.replaceState(null, '', url.toString());
  }

  const facetList = document.querySelector('.voyado-results__facets');
  const previousState = getActiveFacetContainers();
  facetList.innerHTML = '';
  sizeFacetIdToLabel = Object.create(null);

  if (sortOptions && sortOptions.length) {

    const sortItems = sortOptions.map(option => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort', option.id);

      const isActive = sort === option.id;

      return `
        <li class="facet ${isActive ? 'active' : ''}">
          <a href="?${url.searchParams.toString()}">
            <span class="facet-check">${tick}</span>
            ${option.label}
          </a>
        </li>
      `;
    }).join('');

    const sortFacet = document.createElement('div');
    sortFacet.className = 'voyado-results__facet-item';

    sortFacet.innerHTML = `
      <div class="facet-container facet-container--sort active">
        <h2>Sort<span class="chevron">${chev}</span></h2>
        <div class="facet-content">
          <ul>${sortItems}</ul>
        </div>
      </div>
    `;

    facetList.appendChild(sortFacet);
  }

  facets.forEach(facet => {
    let label = facet.label;
    if (facet.label === 'Prd_type') label = 'Type';
    if (facet.label === 'Pursuits') label = 'Activity';
    if (facet.label === 'Fit_guide') label = 'Fit';
    if (facet.label === 'Usps') label = 'Features';
    if (facet.label === 'In stock') label = 'Availability';

    const facetKey =
      facet.type === 'TEXT'
        ? facet.label
        : facet.type === 'CHECKBOX'
          ? facet.id
          : facet.type;
    let itemsHtml = '';

    if (facet.type === 'TEXT' || facet.type === 'COLOR') {
      itemsHtml = buildFacetListItems(facetKey, facet.values);
    }
    if (facet.type === 'SIZE') {
      const sizeValues = facet.sizeTypes?.[0]?.formats?.[0]?.values ?? [];
      sizeValues.forEach(value => {
        sizeFacetIdToLabel[String(value.id)] = value.label;
      });
      itemsHtml = buildFacetListItems(facetKey, sizeValues);
    }

    if (facet.type === 'CHECKBOX') {
      itemsHtml = buildCheckboxFacetItem(facet);
    }

    if (facet.type === 'RANGE') {

      const ranges = [
        { label: 'Under £100', min: 0, max: 100 },
        { label: '£100-£250', min: 100, max: 250 },
        { label: '£250-£500', min: 250, max: 500 },
        { label: '£500-£750', min: 500, max: 750 },
        { label: '£750+', min: 750, max: null },
      ]

      const params = new URLSearchParams(window.location.search)
      const priceMinKey = toFilterParam(`f.${RANGE_FACET_KEY}.min`)
      const priceMaxKey = toFilterParam(`f.${RANGE_FACET_KEY}.max`)
      const currentMin = Number(params.get(priceMinKey))
      const currentMax = Number(params.get(priceMaxKey))

      itemsHtml = ranges.map(range => {

        const url = new URL(window.location.href)

        url.searchParams.set(priceMinKey, range.min)

        if (range.max !== null) {
          url.searchParams.set(priceMaxKey, range.max)
        } else {
          url.searchParams.delete(priceMaxKey)
        }

        const isActive =
          currentMin === range.min &&
          (range.max === null || currentMax === range.max)

        return `
          <li class="facet ${isActive ? 'active' : ''}" data-facet="price">
            <a href="?${url.searchParams.toString()}">
              <span class="facet-check">${tick}</span>
              ${range.label}
            </a>
          </li>
        `

      }).join('')
    }

    const facetItem = document.createElement('div');
    facetItem.className = `voyado-results__facet-item`;
    facetItem.innerHTML = `
      <div class="facet-container${facet.type === 'TEXT' || facet.type === 'SIZE' || facet.type === 'CHECKBOX' ? ' facet-container--' + label : ''}">
        <h2>${label}<span class="chevron">${chev}</span></h2>
        <p class="voyado-results__facet-description"></p>
        <div class="facet-content">
          <ul>${itemsHtml}</ul>
        </div>
      </div>
    `;
    facetList.appendChild(facetItem);

    facetItem.querySelectorAll('.price-range-sliders').forEach(container => {
      const minSlider = container.querySelector('.price-range-min');
      const maxSlider = container.querySelector('.price-range-max');

      const labels = container.closest('ul').querySelector('.price-range');
      const lowerLabel = labels.querySelector('.lower');
      const upperLabel = labels.querySelector('.upper');

      function syncLabels() {
        lowerLabel.textContent = `£${minSlider.value}`;
        upperLabel.textContent = `£${maxSlider.value}`;
      }

      function enforceBounds() {
        if (+minSlider.value > +maxSlider.value) {
          minSlider.value = maxSlider.value;
        }
      }

      minSlider.addEventListener('input', () => {
        enforceBounds();
        syncLabels();
      });

      maxSlider.addEventListener('input', () => {
        enforceBounds();
        syncLabels();
      });

      [minSlider, maxSlider].forEach(slider => {
        slider.addEventListener('change', () => {
          // eslint-disable-next-line compat/compat
          const url = new URL(window.location.href);

          url.searchParams.set(
            toFilterParam(`f.${RANGE_FACET_KEY}.min`),
            minSlider.value,
          );
          url.searchParams.set(
            toFilterParam(`f.${RANGE_FACET_KEY}.max`),
            maxSlider.value,
          );

          history.pushState(null, '', url.toString());
          currentSkip = 0;
          debouncedMain();
        });
      });
    });

  });

  restoreActiveFacetContainers(previousState);

}

// Dashboard update
async function updateDashboard(primaryList, autoCorrect) {
  const resultsAmount = document.querySelector('.search-results-header #results-amount');

  if (autoCorrect) {
    document.querySelector('.search-results-header #results-title').innerHTML = `We’ve matched your search to "${autoCorrect}"`;
  }

  if (primaryList) {
    const totalResults = primaryList.totalHits;
    if (totalResults > 0 && resultsAmount) {
      document.title = `Search: ${totalResults} results found`;
    } else {
      if (resultsAmount) {
        resultsAmount.innerHTML = 'No results found';
        await noResultsFound();
        document.title = `Search: No results found`;
      }
    }
  }
}

// Main search flow
async function main() {
  if (isRendering) return;
  isRendering = true;

  if (currentSkip === 0) {
    failedProducts = 0;
    renderedCount = 0;
    renderedTickets.clear();
  }

  try {
    // eslint-disable-next-line compat/compat
    queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('q')) searchQuery = queryParams.get('q');
    if (queryParams.has('sort')) sort = queryParams.get('sort');

    const facets = {};
    for (const [urlKey, apiKey] of Object.entries(FILTER_PARAM_TO_API)) {
      const param = toFilterParam(urlKey);
      if (queryParams.has(param)) facets[apiKey] = queryParams.get(param);
    }

    const priceMinKey = toFilterParam(`f.${RANGE_FACET_KEY}.min`);
    const priceMaxKey = toFilterParam(`f.${RANGE_FACET_KEY}.max`);
    if (queryParams.has(priceMinKey)) facets['price.min'] = queryParams.get(priceMinKey);
    if (queryParams.has(priceMaxKey)) facets['price.max'] = queryParams.get(priceMaxKey);

    if (queryParams.get(toFilterParam('onlyInStock')) === 'true') {
      facets.onlyInStock = true;
    }

    const skip = currentSkip;

    let result

    if (isCollections) {
      // Ensure we support optional locale prefixes like /en/collections/
      const ref = window.location.pathname.replace(/^\/[a-zA-Z-]+\/collections\/|^\/collections\/|\/$/g, "");
      const pageReference = `/${ref}`;
      const pending = window.elevate.pendingLandingPage;
      const canUsePrefetch =
        skip === 0 &&
        sort === 'RELEVANCE' &&
        Object.keys(facets).length === 0 &&
        pending?.key === `${pageReference}|RELEVANCE|0`;

      if (canUsePrefetch) {
        window.elevate.pendingLandingPage = null;
        result = await pending.promise;
      } else {
        result = await window.elevate.api.query.landingPage({
          pageReference,
          sort,
          facets,
          limit,
          skip,
          notify: window.elevate.predictedConsent,
        });
      }

    } else {
      let origin = 'ORGANIC'
      queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has('origin')) origin = queryParams.get('origin');
      result = await window.elevate.api.query.searchPage({
        q: searchQuery,
        limit,
        skip,
        sort,
        facets, origin, notify: window.elevate.predictedConsent
      });
    }

    const primaryGroups = result?.primaryList?.productGroups ?? [];
    const primaryTotalHits = Number(result?.primaryList?.totalHits) || 0;

    hasMorePrimaryPages =
      primaryGroups.length > 0 && skip + primaryGroups.length < primaryTotalHits;

    baseTotalHits = primaryTotalHits;
    totalHitsState = primaryTotalHits;

    if (totalHitsState > 0 && hasMorePrimaryPages) {
      createPagination(totalHitsState);
    }

    const autocorrect = result?.autoCorrect?.q;
    const totalResults = result?.primaryList?.totalHits;

    if (!isCollections && result?.relatedSearches?.length > 0) {
      createRelatedSearches(result.relatedSearches)
    }

    await createProducts(primaryGroups);
    const plpFailed = isCollections && document.querySelector('[data-voyado-plp="failed"]');

    if (!plpFailed) {
      createFacets(result.primaryList?.facets, result.primaryList?.sort?.options, autocorrect);
      renderSelectedFilters()
      await updateDashboard(result.primaryList, autocorrect);
    }

    if (!isCollections && totalResults < 300 && result.secondaryList) {
      await createSecondaryProducts(result.secondaryList.productGroups, result.secondaryList.totalHits);
      const other = document.querySelector('.text--other-matches');
      if (other != null) {
        other.style.display = 'flex';
      }
    } else {
      const other = document.querySelector('.text--other-matches');
      if (other) other.style.display = 'none';
    }

    if (currentSkip === 0) {
      const restored = restoreScrollPosition();
      if (!restored && (!isCollections || hasTakenOverCollection)) scrollToTop();
      if (isCollections) hasTakenOverCollection = true;
    }

    if (isCollections && !plpFailed) {
      disableNativeLoadMore();
      const wasReady = document.querySelector('[data-voyado-plp="ready"]');
      const productList = document.querySelector('.search-results__results');

      if (!wasReady && productList) {
        await waitForVisibleCardImages(productList);
      }

      setVoyadoPlpState('ready');

      if (wasReady && productList) {
        productList.style.minHeight = '';
      }
    }

  } catch (err) {
    console.warn('Error in main:', err);
    hasMorePrimaryPages = false;
    if (isCollections && !hasTakenOverCollection) setVoyadoPlpState('failed');
  }

  clearFiltersOnClick();

  // Navigation categories are unused on collections (hidden) — skip the extra round trip.
  const cat = document.querySelector('.voyado-results__categories');
  if (!isCollections && cat != null) {
    cat.innerHTML = '';
    const navigation = await window.elevate.api.query.navigationTree();
    navigation.tree.children.forEach(nav => {
      const item = `<div class="category-item">${nav.label}<span>${nav.count}</span></div>`;
      cat.insertAdjacentHTML('afterbegin', item);
    });
  }

  isRendering = false;
  isLoadingMore = false;
  updatePagination();

  if (queuedMain) {
    queuedMain = false;
    main();
  }
}

function bindGlobalEvents() {
  if (eventsBound) return;
  eventsBound = true;

  document.addEventListener('click', e => {

    // PRODUCT CARD CLICK
    const productLink = e.target.closest('.prd-Card a');

    if (productLink) {
      saveScrollPosition();
      return;
    }

    // FACET CLICK
    const facetLink = e.target.closest('.facet a');
    if (facetLink) {
      e.preventDefault();
      history.pushState({}, '', facetLink.href);
      currentSkip = 0;
      if (isRendering) {
        queuedMain = true;
        return;
      }
      main();
      return;
    }

    // LOAD MORE
    if (e.target.closest('.pagination__text')) {
      if (isLoadingMore || isRendering) return;
      if (!hasMorePrimaryPages) return;
      if (isCollections && document.querySelector('[data-voyado-plp]')?.getAttribute('data-voyado-plp') !== 'ready') {
        return;
      }

      isLoadingMore = true;
      currentSkip += limit;

      main().finally(() => {
        isLoadingMore = false;
      });

      return;
    }

    // FILTER TOGGLE
    if (e.target.closest('.voyado-results__sort-options-container h2')) {
      const container = document.querySelector('.search-results-facets');
      const results = document.querySelector('.search-results__results');
      const secResults = document.querySelector('.search-results__results--secondary')
      const textEl = document.querySelector('.filter-text');
      const relatedMargin = document.querySelector('.text--related-searches')
      const otherMargin = document.querySelector('.text--other-matches')

      if (window.innerWidth < 767) {
        document.querySelector('body').classList.toggle('search-overlay')
      }

      container.classList.toggle('active');
      results?.classList.toggle('less-cols');
      secResults?.classList.toggle('less-cols')
      relatedMargin?.classList.toggle('remove-margin')
      otherMargin?.classList.toggle('remove-margin')

      if (textEl) {
        textEl.textContent =
          textEl.textContent === 'Show Filters'
            ? 'Hide Filters'
            : 'Show Filters';
      }
      return;
    }

    // FACET DROPDOWN
    const header = e.target.closest('.voyado-results__facet-item h2');
    if (header) {
      header.parentElement.classList.toggle('active');
    }
  });
}

// BFCache: back/forward can restore this document without re-running module init, so `main()` at the bottom never fires again.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  isRendering = false;
  currentSkip = 0;
  main();
});

currentSkip = 0;
if (typeof window.elevate?.onApiReady === 'function') {
  window.elevate.onApiReady(() => {
    main();
  });
} else {
  window.elevate = window.elevate || {};
  window.elevate.__apiReadyQueue = window.elevate.__apiReadyQueue || [];
  window.elevate.__apiReadyQueue.push(() => main());
}

if (isCollections) {
  const armCollectionFallback = () => {
    window.setTimeout(() => {
      const root = document.querySelector('[data-voyado-plp]');
      if (root?.getAttribute('data-voyado-plp') !== 'pending') return;
      if (isRendering) {
        armCollectionFallback();
        return;
      }
      setVoyadoPlpState('failed');
    }, 8000);
  };
  armCollectionFallback();
}

// Mobile menu
function mobileMenu() {
  const mobileTrigger = document.querySelector('.facets__title--mobile');
  const mobileClose = document.querySelector('.close-for-mobile')

  mobileClose.addEventListener('click', () => {
    document.querySelector('.search-results-facets').classList.remove('active');
    document.querySelector('.facet-container-mobile').classList.remove('voyado-results__facets--open-for-mobile');
    document.querySelector('body').classList.remove('scroll-lock')
    document.querySelector('body').classList.remove('search-overlay')
  })

  mobileTrigger?.addEventListener('click', () => {
    document.querySelector('.search-results-container').classList.add('voyado-results__facets--open-for-mobile');
    document.querySelector('.facet-container-mobile').classList.add('voyado-results__facets--open-for-mobile');
    document.querySelector('body').classList.add('scroll-lock')
  });
}
mobileMenu();

function createPagination(totalHits) {
  let pagination = document.querySelector('.search-results-container .pagination');

  if (!pagination) {
    const html = `
      <div class="pagination">
        <div class="pagination__text btn-Button-secondary">LOAD MORE RESULTS</div>
        <div class="pagination__bar">
          <span class="pagination__shown">0</span>
          <div class="progress-outer">
            <span class="pagination__progress"></span>
          </div>
          <span class="pagination__total">${totalHits}</span>
        </div>
      </div>
    `;

    const anchor =
      document.querySelector('load-more-list') ||
      document.querySelector('.search-results__results');
    anchor?.insertAdjacentHTML('afterend', html);
  }

  updatePagination();
}

function updatePagination() {
  const pagination = document.querySelector('.search-results-container .pagination');
  if (!pagination) return;

  const showing = renderedCount;
  const denom = totalHitsState;
  const atCatalogEnd = denom > 0 && !hasMorePrimaryPages;

  const progress = denom > 0
    ? (atCatalogEnd ? 100 : Math.min((showing / denom) * 100, 100))
    : 0;

  pagination.querySelector('.pagination__shown').textContent = showing;
  pagination.querySelector('.pagination__progress').style.width = `${progress}%`;
  pagination.querySelector('.pagination__total').textContent = totalHitsState;
  pagination.classList.toggle('is-loading', isLoadingMore);
  pagination.style.display = denom > 0 && hasMorePrimaryPages ? 'block' : 'none';

}

function getPriceLabel(min, max) {

  min = Number(min)
  max = Number(max)

  if (min === 0 && max === 100) return 'Under £100'
  if (min === 100 && max === 250) return '£100–£250'
  if (min === 250 && max === 500) return '£250–£500'
  if (min === 500 && max === 750) return '£500–£750'
  if (min === 750) return '£750+'

  return `£${min}–£${max}`
}

function renderSelectedFilters() {

  const container = document.querySelector('.selected-filters')
  // eslint-disable-next-line compat/compat
  const params = new URLSearchParams(window.location.search)

  container.innerHTML = ''
  let filterAmount = 0;

  const priceMinKey = toFilterParam(`f.${RANGE_FACET_KEY}.min`)
  const priceMaxKey = toFilterParam(`f.${RANGE_FACET_KEY}.max`)
  const priceMin = params.get(priceMinKey)
  const priceMax = params.get(priceMaxKey)

  if (priceMin) {

    filterAmount++

    const tag = document.createElement('div')
    tag.className = 'selected-filter'

    tag.innerHTML = `
      ${getPriceLabel(priceMin, priceMax)}
      <span class="remove">✕</span>
    `

    tag.addEventListener('click', () => {

      const url = new URL(window.location.href)

      url.searchParams.delete(priceMinKey)
      url.searchParams.delete(priceMaxKey)

      history.pushState({}, '', url)

      currentSkip = 0
      main()

    })

    container.appendChild(tag)

  }

  const onlyInStockKey = toFilterParam('onlyInStock');
  if (params.get(onlyInStockKey) === 'true') {
    filterAmount++;

    const tag = document.createElement('div');
    tag.className = 'selected-filter';

    tag.innerHTML = `
      in stock
      <span class="remove">✕</span>
    `;

    tag.addEventListener('click', () => {
      const url = new URL(window.location.href);

      url.searchParams.delete(onlyInStockKey);

      history.pushState({}, '', url);

      currentSkip = 0;
      main();
    });

    container.appendChild(tag);
  }

  params.forEach((value, key) => {
    if (!isFilterParam(key)) return;

    const facetKey = fromFilterParam(key);
    if (
      facetKey === `f.${RANGE_FACET_KEY}.min` ||
      facetKey === `f.${RANGE_FACET_KEY}.max` ||
      facetKey === 'onlyInStock'
    ) return;

    const values = value.split('|')

    values.forEach(v => {

      filterAmount++

      const tag = document.createElement('div')
      tag.className = `selected-filter`
      tag.dataset.identifier = v
      tag.dataset.paramKey = key

      let filterName = facetKey === 'SIZE' ? (sizeFacetIdToLabel[String(v)] ?? v) : v

      if (facetKey === 'SIZE' && !(String(v) in sizeFacetIdToLabel)) {
        if (v.includes(';SML;XS')) {
          filterName = 'XS'
        }

        if (v.includes(';SML;S')) {
          filterName = 'S'
        }

        if (v.includes(';SML;M')) {
          filterName = 'M'
        }

        if (v.includes(';SML;L')) {
          filterName = 'L'
        }

        if (v.includes(';SML;XL')) {
          filterName = 'XL'
        }

        if (v.includes(';SML;XXL')) {
          filterName = 'XXL'
        }

        if (v.includes(';SML;3XL')) {
          filterName = '3XL'
        }
      }

      if (v.includes('GRAY')) {
        filterName = 'Grey'
      }

      tag.innerHTML = `
        ${filterName}
        <span class="remove">✕</span>
      `

      tag.addEventListener('click', () => {
        // eslint-disable-next-line compat/compat
        const url = new URL(window.location.href)
        const paramKey = tag.dataset.paramKey
        const current = url.searchParams.get(paramKey).split('|')

        const updated = current.filter(x => x !== tag.dataset.identifier)

        if (updated.length)
          url.searchParams.set(paramKey, updated.join('|'))
        else
          url.searchParams.delete(paramKey)

        history.pushState({}, '', url)
        currentSkip = 0
        main()

      })

      container.appendChild(tag)

    })
  })

  if (filterAmount >= 1) {
    document.querySelector('.selected-filter-amount').innerHTML = `[${filterAmount}]`;
    document.querySelector('.selected-filters').classList.add('active')
  } else {
    document.querySelector('.selected-filter-amount').innerHTML = ``;
    document.querySelector('.selected-filters').classList.remove('active')
  }

}

function createRelatedSearches(relatedSearches) {
  document.querySelector('.text--related-searches').classList.remove('hide')
  const links = document.querySelector('.related-search-links')

  links.innerHTML = '';

  relatedSearches.forEach((search) => {
    const element = `<div class="related-search-link"><a href="?q=${search.q}">${search.q}</a></div>`
    links.insertAdjacentHTML('afterbegin', element)
  })

}

async function noResultsFound() {
  document.querySelector('#results-amount').innerHTML = '[0]'
  document.querySelector('.voyado-results__sort-options-container').style.display = 'none'
  const resultsContainer = document.querySelector('.search-results-container')
  resultsContainer.classList.add('search-results-container--no-results')

  const noResults = document.createElement('div')
  noResults.classList.add('no-results')
  noResults.classList.add('lyt-Container')
  noResults.innerHTML = `<p>No results could be found.<span> Refine your search or explore trending pieces below.</span></p><h2>Trending Right Now</h2>`

  resultsContainer.insertAdjacentElement('beforebegin', noResults)

  // call recs function here....
  const recs = await getForYouResults();
  const results = await Promise.all(
    recs.slice(0, 12).map(group =>
      getProductInfo(group.products[0].key, group.products[0].ticket)
    )
  );

  const productGrid = document.querySelector('.search-results__results');

  if (productGrid) {
    await renderProducts(results, productGrid);
  }
}

async function getForYouResults() {
  if (cachedForYou) return cachedForYou;

  const res = await window.elevate.api.query.landingPage(
    { pageReference: '/' },
    {
      recommendationLists: [
        { id: 'PERSONAL-1', algorithm: 'PERSONAL' },
      ],
    },
  );

  cachedForYou = res?.recommendationLists?.[0]?.productGroups || [];
  return cachedForYou;
}

window.addEventListener('popstate', () => {
  currentSkip = 0;
  main();
});

bindGlobalEvents();
